"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatForn = void 0;
var bson_1 = require("bson");
var MatForn = /** @class */ (function () {
    function MatForn(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CD_FORN, CD_FORN = _c === void 0 ? '' : _c, _d = _a.MATERIAL, MATERIAL = _d === void 0 ? '' : _d, _e = _a.NODE, NODE = _e === void 0 ? '' : _e, _f = _a.CD_FABRICA, CD_FABRICA = _f === void 0 ? '' : _f;
        this._id = _id;
        this.CD_FORN = CD_FORN;
        this.MATERIAL = MATERIAL;
        this.NODE = NODE;
        this.CD_FABRICA = CD_FABRICA;
    }
    return MatForn;
}());
exports.MatForn = MatForn;
//# sourceMappingURL=MatForn.js.map